var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0000ee",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 1,
    d: "M58.446,17.095c-0.828,0-1.5,0.671-1.5,1.5s0.672,1.5,1.5,1.5c16.491,0,29.907,13.415,29.907,29.905 c0,16.489-13.416,29.904-29.907,29.904c-12.403,0-23.431-7.698-27.856-19.052l1.994,0.887c0.758,0.338,1.644-0.005,1.98-0.762 s-0.004-1.644-0.761-1.98l-5.128-2.279c-0.739-0.327-1.603-0.013-1.958,0.713l-2.273,4.655c-0.363,0.744-0.054,1.643,0.69,2.006 c0.212,0.104,0.436,0.152,0.657,0.152c0.555,0,1.089-0.31,1.349-0.842l0.672-1.377c4.889,12.451,17.015,20.879,30.633,20.879 c18.146,0,32.907-14.761,32.907-32.904S76.592,17.095,58.446,17.095z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000ee",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 1,
    d: "M46.653,42.604V23.506c0-0.829-0.671-1.5-1.5-1.5H10.145c-0.829,0-1.5,0.671-1.5,1.5v19.098c0,0.829,0.671,1.5,1.5,1.5 h35.008C45.981,44.104,46.653,43.433,46.653,42.604z M43.653,41.104H11.645V25.006h32.008V41.104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000ee",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 1,
    d: "M27.65,38.431c2.965,0,5.378-2.413,5.378-5.378s-2.413-5.378-5.378-5.378s-5.378,2.413-5.378,5.378 S24.685,38.431,27.65,38.431z M27.65,30.675c1.311,0,2.378,1.067,2.378,2.378s-1.067,2.378-2.378,2.378s-2.378-1.067-2.378-2.378 S26.339,30.675,27.65,30.675z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0000ee",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 1,
    d: "M42.327,66.188c0.293,0.293,0.677,0.439,1.061,0.439s0.768-0.146,1.061-0.439l14.756-14.766 c0.281-0.281,0.439-0.663,0.439-1.061V29.026c0-0.829-0.672-1.5-1.5-1.5s-1.5,0.671-1.5,1.5V49.74L42.326,64.066 C41.741,64.652,41.741,65.603,42.327,66.188z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.ec4344276571d7956fc5ff21934d19e2.svg";
export { ForwardRef as ReactComponent };